<template>
    <div>
        <div class="vx-row w-full mb-base mt-3" v-if="keywordDataLength > 0">
            <vx-card>
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <h4>Performances des Top keywords {{ toDate ? (getMonthFrench(parseInt(toDate.substring(5,7)) - 1)).toLowerCase() + " " + toDate.substring(0,4) : "" }} VS mois précédent (SERP Top 100 Google)</h4>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col vs-con-loading__container" id="rc-top-keywords">
                  <div >
                    <report-card
                      ref="rc-top-keywords"
                      tooltiptext="Total des keywords sur lesquels le site remonte dans Google."
                      title="Nb. Top Keywords"
                      :statistics="keywordNumberEvolution.statistics"
                      :icon="keywordNumberEvolution.icon"
                      :icontext="keywordNumberEvolution.itext"
                      :color="keywordNumberEvolution.color"
                      :value="keywordNumberEvolution.value"
                      emithandler="show-keywords-diff"
                      @show-keywords-diff="emit('show-keywords-diff')"
                      valtext="vs M-1"
                      :width="270"
                    />
                  </div>
                </div>
                <div class="vx-col vs-con-loading__container" id="rc-positions" >
                  <report-card
                    ref="rc-positions"
                    tooltiptext="Position moyenne des keywords sur lesquels le site remonte dans Google."
                    title="Position moyenne"
                    :statistics="averagePositionEvolution.statistics"
                    :icon="averagePositionEvolution.icon"
                    :icontext="averagePositionEvolution.itext"
                    :color="averagePositionEvolution.color"
                    :value="averagePositionEvolution.value"
                    valtext="vs M-1"
                    :invertval="true"
                    :width="270"
                  />

                </div>
                <div class="vx-col vs-con-loading__container" v-if="topKeywordsSEOValue && topKeywordsSEOValue.length > 0" id="rc-seo-value">
                  <report-card
                    ref="rc-seo-value"
                    tooltiptext="Valeur totale du SEO du site calculée en fonction de la position sur Google, du CTR estimé, du CPC Google Ads, et des volumes de recherche mensuels pour tous les Top Keywords."
                    title="Valeur du SEO"
                    :statistics="seoValueEvolution.statistics + '€'"
                    :icon="seoValueEvolution.icon"
                    :icontext="seoValueEvolution.itext"
                    :color="seoValueEvolution.color"
                    :value="seoValueEvolution.value  + '€'"
                    valtext="vs M-1"
                    :width="270"
                  />
                </div>
                <div v-if="societyIsEcommerce == 1" class="vx-col vs-con-loading__container" id="rc-organic-revenue">
                  <report-card
                    ref="rc-organic-revenue"
                    v-if="societyIsEcommerce == 1"
                    tooltiptext="Chiffre d'affaires de l'organique du mois actuel comparé à celui du mois dernier."
                    title="CA Organique"
                    :statistics="revenueEvolution.statistics + '€'"
                    :icon="revenueEvolution.icon"
                    :icontext="revenueEvolution.itext"
                    :color="revenueEvolution.color"
                    :value="revenueEvolution.value  + '€'"
                    emithandler="show-transactions-diff"
                    @show-transactions-diff="emit('show-transactions-diff')"
                    valtext="vs M-1"
                    :width="270"
                  />
                </div>
                <div class="vx-col vs-con-loading__container" id="rc-organic-conversion">
                  <report-card
                    ref="rc-organic-conversion"
                    tooltiptext="Conversion de l'organique du mois actuel comparé à celui du mois dernier."
                    title="Conversion Organique"
                    :statistics="conversionEvolution.statistics"
                    :icon="conversionEvolution.icon"
                    :icontext="conversionEvolution.itext"
                    :color="conversionEvolution.color"
                    :value="conversionEvolution.value"
                    emithandler="show-conversions-diff"
                    @show-conversions-diff="emit('show-conversions-diff')"
                    valtext="vs M-1"
                    :width="270"
                  />
                </div>
              </div>
              <div class="vx-row mb-2">
                  <div class="vx-col">
                    <h4>Nombre de top keywords et Valeur du SEO</h4>
                  </div>
                </div>
                <div id="apex-perf-keywords" ref="apex-perf-keywords" class="vx-col w-full vs-con-loading__container">
                  <apexchart
                      v-if="perfDataKeywordsAreaChart && perfDataKeywordsAreaChart.chartOptions && perfDataKeywordsAreaChart.series"
                      ref="perfDataChartKeywords"
                      type="area"
                      height="350"
                      :options="perfDataKeywordsAreaChart.chartOptions"
                      :series="perfDataKeywordsAreaChart.series"
                    ></apexchart>
                </div>
            </vx-card>
          </div>

          <div class="vx-row w-full mt-3" v-if="(topKeywordsLength > 0 || keywordDataLength > 0)">
            <vx-card
            >
            <div class="vx-row">
              <div class="vx-col">
                <h4 class="pt-3">Position des Top Keywords et Keywords dans Google (SERP Top 100 Google)</h4>
              </div>
              <div class="vx-col">
                <vx-tooltip text="Évolution de la répartition des positions du site sur Google pour tous les Keywords ou Top Keywords.">
                  <vs-avatar text="?" style="cursor: default;"></vs-avatar>
                </vx-tooltip>
              </div>
            </div>
            <vs-tabs>
              <vs-tab label="Top Keywords">
                <div class="vs-con-loading__container" id="apex-stacked-top-keywords">
                  <apexchart
                    ref="apex-stacked-top-keywords"
                    v-if="stackedColumnChartOptionTopKeywords && stackedColumnChartOptionTopKeywords.chartOptions && stackedColumnChartOptionTopKeywords.series"
                    type="bar"
                    height="350"
                    :options="changeCursor(stackedColumnChartOptionTopKeywords.chartOptions)"
                    :series="stackedColumnChartOptionTopKeywords.series"
                  ></apexchart>
                </div>
              </vs-tab>
              <vs-tab label="Keywords">
                <div class="vs-con-loading__container" id="apex-stacked-keywords">
                  <apexchart
                    ref="apex-stacked-keywords"
                    v-if="stackedColumnChartOptionKeywords && stackedColumnChartOptionKeywords.chartOptions && stackedColumnChartOptionKeywords.series"
                    type="bar"
                    height="350"
                    :options="changeCursor(stackedColumnChartOptionKeywords.chartOptions)"
                    :series="stackedColumnChartOptionKeywords.series"
                  ></apexchart>
                </div>
              </vs-tab>
            </vs-tabs>
            </vx-card>
          </div>

          <div id="table-perf-top-keywords" ref="table-perf-top-keywords" class="vx-row w-full mt-8 vs-con-loading__container" v-if="topKeywordsLength > 0">
            <vx-card>
              <div class="vx-row">
                <div class="vx-col">
                  <h4 class="pt-3">Performances détaillées des Top Keywords</h4>
                </div>
                <div class="vx-col">
                  <vx-tooltip text="Valeur du SEO de chaque Top Keyword calculée en fonction de la position sur Google, du CTR estimé, du CPC Google Ads, et des volumes de recherche mensuels.">
                    <vs-avatar text="?" style="cursor: default;"></vs-avatar>
                  </vx-tooltip>
                </div>
                <div class="vx-col" v-if="seoValueByKeywordPreviousMonthWarning">
                  <vx-tooltip text="Les données du mois actuel sont encore en cours d'actualisation, les données présentées sont celles du mois précédent.">
                    <vs-icon class="pt-3" icon="warning" size="medium" color="gray" />
                  </vx-tooltip>
                </div>
                <div class="vx-col pt-2">
                  <span>Nombre de lignes affichées : </span>
                </div>
                <div class="vx-col">
                  <vs-select
                    autocomplete
                    v-model="maxItemsTopKeywordsSEOValueByKeyword"
                    class="select-large pb-4"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item"
                      :text="item"
                      v-for="(item, index) in pageNumberOptions"
                      class="w-full"
                    />
                  </vs-select>
                </div>
                <div class="vx-col pt-2">
                  <span>Recherche par keyword : </span>
                </div>
                <div class="vx-col">
                  <vs-input class="inputx" placeholder="Keyword" v-model="keywordSeoValueSearchInput"  />
                </div>
              </div>
              <div class="vx-row">
                  <div class="vx-col py-2">
                      <strong>Nombre de top keywords : {{ tkTableLength }}</strong>
                  </div>

                  <div class="vx-col py-2">
                      <strong>Volume de recherche total : {{ tkTableTotalVolume }}</strong>
                  </div>
              </div>
              <vs-table ref="topKeywordsSEOValueByKeyword" v-if="topKeywordsSEOValueByKeyword && topKeywordsSEOValueByKeyword.length > 0" stripe hoverFlat auto-resize pagination :max-items="maxItemsTopKeywordsSEOValueByKeyword" noDataText="" :data="topKeywordsSEOValueByKeyword" class="mt-2">
                <template slot="thead">
                  <vs-th sort-key="keyword">Keywords</vs-th>
                  <vs-th sort-key="position" class="px-2" style="width: 60px;"><vs-spacer/>Position</vs-th>
                  <vs-th sort-key="volume" class="px-2" style="width: 60px;"><vs-spacer/>Recherches mensuelles</vs-th>
                  <vs-th sort-key="clicks" class="px-2" style="width: 60px;"><vs-spacer/>Trafic généré</vs-th>
                  <vs-th sort-key="cpc" class="px-2" style="width: 60px;"><vs-spacer/>CPC Google</vs-th>
                  <vs-th sort-key="kd" class="px-2" style="width: 60px;"><vs-spacer/>
                    <vx-tooltip text="Keyword Difficulty">
                      KD
                    </vx-tooltip>
					<vs-spacer/>
                  </vs-th>
                  <vs-th sort-key="value" class="px-2" style="width: 60px;"><vs-spacer/>Valeur du SEO</vs-th>
                  <vs-th></vs-th>
                  <vs-th class="px-2" style="pointer-events:none;width: 60px;">% du total de la valeur du SEO</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="index" v-for="(row,index) of data">
                    <vs-td><strong>{{ row.keyword }}</strong></vs-td>
                    <vs-td v-if="row.position == 101" class="txt_align_right"><vs-icon icon="schedule" size="small" color="primary" /></vs-td>
                    <vs-td v-else-if="row.position == 100" class="txt_align_right"><strong>ABS</strong></vs-td>
                    <vs-td v-else-if="row.position > 0" class="txt_align_right"><strong>{{ row.position }}</strong></vs-td>
                    <vs-td class="txt_align_right"><strong>{{ row.volume == 0 || row.volume == null ? 0 : formatThousandNumb(row.volume) }}</strong></vs-td>

                    <vs-td v-if="row.clicks == -1" class="txt_align_right">-</vs-td>
                    <vs-td v-else class="txt_align_right">{{ row.clicks ? formatThousandNumb(row.clicks) : 0 }}</vs-td>

                    <vs-td class="txt_align_right">{{ row.cpc }}€</vs-td>
                    <vs-td class="txt_align_right pl-6"><vs-chip
                                    style="color: white; border-radius: 8px; width: 35px; margin-right: 20px;"
                                    :color="computeResultColorFromDifferenceKD(61, 219, 80, 252, 186, 3, 204, 41, 87, row.kd)"
                                >{{ row.kd }}</vs-chip></vs-td>
                    <vs-td v-if="!row || row.position != 101" class="txt_align_right">
                      <h4 class="mr-2">{{ !row ? 0 : formatThousandNumb(Math.round(row.value)) }}€</h4>
                    </vs-td>
                    <vs-td v-else class="txt_align_right">
                      <vs-icon icon="schedule" size="small" color="primary" />
                    </vs-td>
                    <vs-td style="width: 200px;">
                      <vs-progress class="mt-2" :percent="row && topKeywordsSEOValue[0] ? Number(formatValue((row.value / topKeywordsSEOValue[0].value) * 100, 2)) : 0"></vs-progress>
                    </vs-td>
                    <vs-td v-if="row && topKeywordsSEOValue[0]" style="width: 200px;">
                      {{ row && topKeywordsSEOValue[0] && topKeywordsSEOValue[0].value ? formatValue((row.value / topKeywordsSEOValue[0].value) * 100, 2) : 0}}%
                    </vs-td>
                    <vs-td v-else style="width: 200px;">
                      <vs-icon icon="schedule" size="small" color="primary" />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
    </div>
</template>
<script>
import utilsMixin from "@/mixins/utilsMixin";
import ReportCard from "@/components/views/dashboard/statistics-cards/ReportCard.vue";
export default {
	name: "KeywordsGeneral",
	mixins: [utilsMixin],
	components: {
		ReportCard
	},
	props: {
		keywordDataLength: { // Object.keys(keywordData).length
			type: Number,
			default: 0
		},
		topKeywordsLength: { // topKeywords.length
			type: Number,
			default: 0
		},
		societyIsEcommerce: { // selectedSociety.is_ecommerce
			type: Number,
			default: 0
		},
		seoValueByKeywordPreviousMonthWarning: {
			type: Boolean,
			default: false
		},
		toDate: { // statDateFilter.toDate
			type: String,
			default: ""
		},
		keywordNumberEvolution: {
			type: Object,
			default: null
		},
		averagePositionEvolution: {
			type: Object,
			default: null
		},
		seoValueEvolution: {
			type: Object,
			default: null
		},
		revenueEvolution: {
			type: Object,
			default: null
		},
		conversionEvolution: {
			type: Object,
			default: null
		},
		perfDataKeywordsAreaChart: {
			type: Object,
			default: null
		},
		stackedColumnChartOptionTopKeywords: {
			type: Object,
			default: null
		},
		stackedColumnChartOptionKeywords: {
			type: Object,
			default: null
		},
		topKeywordsSEOValue: {
			type: Array,
			default: () => []
		},
		topKeywordsSEOValueByKeyword: {
			type: Array,
			default: () => []
		},
		pageNumberOptions: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		keywordSeoValueSearchInput: function(data){
			this.$refs.topKeywordsSEOValueByKeyword.searchx = data;
			this.countTkTableLengthAndTotalVolume(data);
		},
		topKeywordsSEOValueByKeyword: {
			deep: true,
			handler: function(){
				this.countTkTableLengthAndTotalVolume();
			}
		},
	},
	data(){
		return {
			maxItemsTopKeywordsSEOValueByKeyword: 25,
			keywordSeoValueSearchInput: "",
			tkTableLength: 0,
			tkTableTotalVolume: 0
		};
	},
	created() {
		this.countTkTableLengthAndTotalVolume();
	},
	methods: {
		changeCursor(options){
			let option = {...options};
			option["chart"]["events"]["dataPointMouseEnter"] = (e) => {
				e.path[0].style.cursor = "pointer";
			};
			//console.log(option);
			return option;
		},
		computeResultColorFromDifferenceKD(r, g, b, r2, g2, b2, r3, b3, g3, value){
			let returnedColor = {
				r: 0,
				g: 0,
				b: 0
			};
			let maxKd = 100;
			let midKd = 50;
			let minKd = 0;
			if(value <= minKd){
				returnedColor.r = r;
				returnedColor.g = g;
				returnedColor.b = b;
			}
			else if(value <= midKd){
				let colorChangePercentage = ((value - minKd)) / (midKd - minKd);
				let colorMinMidDiff = {
					rdiff: r - r2,
					gdiff: g - g2,
					bdiff: b - b2
				};
				returnedColor.r = r - ((colorMinMidDiff.rdiff * colorChangePercentage));
				returnedColor.g = g - ((colorMinMidDiff.gdiff * colorChangePercentage));
				returnedColor.b = b - ((colorMinMidDiff.bdiff * colorChangePercentage));
			}
			else if(value >= maxKd){
				returnedColor.r = r3;
				returnedColor.g = g3;
				returnedColor.b = b3;
			}
			else{
				let colorChangePercentage = ((value - midKd)) / (maxKd - midKd);
				let colorMidMaxDiff = {
					rdiff: r2 - r3,
					gdiff: g2 - g3,
					bdiff: b2 - b3
				};
				returnedColor.r = r2 - ((colorMidMaxDiff.rdiff * colorChangePercentage));
				returnedColor.g = g2 - ((colorMidMaxDiff.gdiff * colorChangePercentage));
				returnedColor.b = b2 - ((colorMidMaxDiff.bdiff * colorChangePercentage));
			}
			return `rgb(${returnedColor.r}, ${returnedColor.g}, ${returnedColor.b})`;
		},
		countTkTableLengthAndTotalVolume(searchString=""){
			let tkCounter = 0;
			let tkTotalVolume = 0;
			if(searchString){
				for(let index = 0; index < this.$props.topKeywordsSEOValueByKeyword.length; index++){
					if(this.$props.topKeywordsSEOValueByKeyword[index].keyword.includes(searchString)){
						tkCounter +=1;
						tkTotalVolume += this.$props.topKeywordsSEOValueByKeyword[index].volume;
					}
				}
				this.tkTableLength = tkCounter;
				this.tkTableTotalVolume = tkTotalVolume;
			}
			else{
				if(this.$props.topKeywordsSEOValueByKeyword && this.$props.topKeywordsSEOValueByKeyword.length > 0){
					this.tkTableLength = this.$props.topKeywordsSEOValueByKeyword.length;
					for(let index = 0; index < this.$props.topKeywordsSEOValueByKeyword.length; index++){
						tkTotalVolume += this.$props.topKeywordsSEOValueByKeyword[index].volume;
					}
					this.tkTableTotalVolume = tkTotalVolume;
				}
				else{
					this.tkTableLength = 0;
					this.tkTableTotalVolume = 0;
				}
			}
		},
		emit(event){
			this.$emit(event);
		},
		getItext(txt, val){
			if(!val || val == 0) return "=";
			else return txt;
		},
		openLoadingContainer(containerId){
			if(this.$refs[containerId]){
				this.$vs.loading({
					container: "#" + containerId
				});
			}
		},
		closeLoadingContainer(containerId){
			this.$vs.loading.close("#" + containerId + " > .con-vs-loading");
		}
	},
};
</script>
<style lang="scss" scoped>
.txt_align_right {
  text-align: right !important;
}

</style>